/** 奖品类型 */
export const PRIZETYPE = [
  // { label: '微信立减金', value: 'VOUCHER' },
  { label: '微信红包', value: 'RED_PACKET' },
  // { label: '支付宝红包', value: 'ZFB_RED_PACKET' },
];

/**对账依据 */
export const RECONCILIATION_BAS = [
  { label: '领取', value: 'RECEIVED' },
  { label: '补发', value: 'REISSUED' },
];

export const createOpts = (keys: { [index: string]: string }) => {
  if (!keys) return [];
  return Object.keys(keys).map((key) => {
    return {
      label: keys[key],
      value: key,
    };
  });
};
/**活动类型 */
export const ACTIVITY_CONFIG = {
  LAO_HU_JI: '老虎机',
  ZHUAN_PAN: '大转盘',
  JIU_GONG_GE: '九宫格',
  HAI_BAO: '海报类',
  JIE_RI_HAI_BAO: '节假日海报类',
  DISASTER: '防灾减损',
  DISASTER_REMINDER: '防灾提醒',
  TRAFFIC: '安全驾驶答题',
  GUA_GUA_LE: '刮刮乐',
  FAN_PAI: '翻牌',
  ZA_JIN_DAN: '砸金蛋',
  SATISFIED: '车险问卷调研',
  RETURNVISIT: '客户回访',
  CLAIMS_RESEARCH: '理赔调研',
  // KNOWLEDGE: '知识问答',
  // SAFE_DRIVING: '安全驾驶',
  // CAR: '车辆类',
};

// 重庆太保 答题类 相关活动
export const CQ_TB = [
  'SATISFIED',
  'RETURNVISIT',
  // , 'KNOWLEDGE',
  //  'SAFE_DRIVING'
];
export const ACTIVITY_OPTIONS = createOpts(ACTIVITY_CONFIG);

/**活动状态 */
export const ACTIVITY_STATUS_CONFIG = {
  ON_GOING: '进行中',
  TO_START: '待开始',
  ENDED: '已结束',
};
export const ACTIVITY_STATUS_OPTIONS = createOpts(ACTIVITY_STATUS_CONFIG);

/**活动开关 */
export const ACTIVITY_ENABLE_CONFIG = {
  ON: '已开启',
  OFF: '已关闭',
};
export const ACTIVITY_ENABLE_OPTIONS = createOpts(ACTIVITY_ENABLE_CONFIG);

export const ACTIVITY_TREE_OPTIONS = [
  {
    type: '',
    name: '全部',
    level: 4,
    parentId: 1,
    child: [
      {
        type: 'DRAW_PRIZE',
        name: '抽奖类',
        level: 5,
        parentId: 4,
        selectable: false,
        child: [
          {
            type: 'LAO_HU_JI',
            name: '老虎机',
            level: 6,
            parentId: 24,
            child: [],
          },
          {
            type: 'ZHUAN_PAN',
            name: '转盘',
            level: 6,
            parentId: 24,
            child: [],
          },
          {
            type: 'JIU_GONG_GE',
            name: '九宫格',
            level: 6,
            parentId: 24,
            child: [],
          },
          {
            type: 'GUA_GUA_LE',
            name: '刮刮乐',
            level: 6,
            parentId: 24,
            child: [],
          },
          {
            type: 'FAN_PAI',
            name: '翻牌',
            level: 6,
            parentId: 24,
            child: [],
          },
          {
            type: 'ZA_JIN_DAN',
            name: '砸金蛋',
            level: 6,
            parentId: 24,
            child: [],
          },
        ],
      },
      {
        type: 'PUBLICIZE',
        name: '宣传类',
        level: 5,
        parentId: 4,
        selectable: false,
        child: [
          {
            type: 'HAI_BAO',
            name: '海报类',
            level: 6,
            parentId: 23,
            child: [],
          },
          {
            type: 'JIE_RI_HAI_BAO',
            name: '节假日海报',
            level: 6,
            parentId: 23,
            child: [],
          },
        ],
      },
      {
        type: 'QUESTION',
        name: '答题类',
        level: 5,
        parentId: 4,
        selectable: false,
        child: [
          // {
          //   type: 'CAR',
          //   name: '车辆类',
          //   level: 6,
          //   parentId: 23,
          //   child: []
          // },
          {
            type: 'DISASTER',
            name: '防灾减损',
            level: 6,
            parentId: 23,
            child: [],
          },
          {
            type: 'DISASTER_REMINDER',
            name: '防灾提醒',
            level: 6,
            parentId: 23,
            child: [],
          },
          {
            type: 'TRAFFIC',
            name: '安全驾驶答题',
            level: 6,
            parentId: 23,
            child: [],
          },
          {
            type: 'SATISFIED',
            name: '车险问卷调研',
            level: 6,
            parentId: 23,
            child: [],
          },
          {
            type: 'RETURNVISIT',
            name: '客户回访',
            level: 6,
            parentId: 23,
            child: [],
          },
          {
            type: 'CLAIMS_RESEARCH',
            name: '理赔调研',
            level: 6,
            parentId: 23,
            child: [],
          },
          // {
          //   type: 'KNOWLEDGE',
          //   name: '知识问答',
          //   level: 6,
          //   parentId: 23,
          //   child: [],
          // },
          // {
          //   type: 'SAFE_DRIVING',
          //   name: '安全驾驶',
          //   level: 6,
          //   parentId: 23,
          //   child: [],
          // },
        ],
      },
    ],
  },
];

export const QUESTIONS = ['DISASTER', 'TRAFFIC', 'SATISFIED', 'DISASTER_REMINDER'];

export const CUSTOMER_REBATES_OPTIONS = [
  { label: '待处理', value: 'PENDING' },
  { label: '不返利', value: 'UN_REBATE' },
  { label: '进行中', value: 'REBATING' },
  { label: '已返利', value: 'RECEIVED' },
];

export const REDEEM_STATUS_OPTIONS = [
  { label: '兑换', value: 'DISBURSE' },
  { label: '获取', value: 'INCOME' },
];

export const COUPON_STATUS_OPTIONS = [
  { label: '未使用', value: 'UN_USED' },
  { label: '已使用', value: 'USED' },
  { label: '已过期', value: 'EXPIRED' },
  { label: '发放异常', value: 'ABNORMAL_AND_REISSUING' },
];
